export default __webpack_public_path__ + "static/media/student-work8.0a918f71.jpeg";